import { assignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
/**
 *
 * @param setting Setting provided from BE to assign as an XP
 */ export var assignSettingOnEvent = function(setting) {
    if (setting) {
        assignSetting(setting);
    }
};
